import React, { Component } from 'react';
import _ from 'lodash';

import { Link } from 'react-router-dom';
import { openSubmenu, closeSubmenu } from "./LayoutHelpers";

class CustMenuItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            item: props.item
        };
    }

    componentDidMount() {
        const { location } = this.props;

        this.handleActiveItem(location.pathname, null);
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;

        this.handleActiveItem(location.pathname, prevProps.location.pathname);
    }

    expandMenu = () => {
        const { itemId } = this.props;
        const { item } = this.state;
        const newItem = item;
        const element = document.getElementById(itemId);

        if (newItem.style && newItem.style === 'active') {
            newItem.style = closeSubmenu(element);
        } else {
            newItem.style = openSubmenu(element);
        }

        this.setState({
            item: newItem
        });
    };

    handleActiveItem = (location, prevLocation) => {
        const { itemId } = this.props;
        const { item } = this.state;
        const newItem = item;

        const element = document.getElementById(itemId);

        let isActive = false;

        if (location !== prevLocation) {
            if(newItem.isMenu) {
                newItem.subItems.forEach( subItem => {
                    if (subItem.url === location.substring(0, subItem.url.length)) {
                        subItem.style = 'active';
                        isActive = true;
                    } else {
                        subItem.style = '';
                    }
                });
                if(isActive) {
                    if (!(newItem.style && newItem.style === 'active')) {
                        newItem.style = openSubmenu(element);
                    }
                } else {
                    newItem.style = closeSubmenu(element);
                }
            } else {
                if (newItem.url === location) {
                    newItem.style = 'active';
                } else {
                    newItem.style = '';
                }
            }
            this.setState({
                item: newItem
            });
        }
    };

    render() {
        const { itemId } = this.props;
        const { item } = this.state;

        const renderItem = item.isMenu
            ? <li className={item.style}>
                <Link
                    className='has-arrow'
                    to="#"
                    onClick={ this.expandMenu }
                >
                    <div className="mini-item">{_.capitalize(item.label.substring(0, 3))}</div>
                    <span className="nav-label">{_.upperCase(item.label)}</span>
                    <span className="fa arrow"></span>
                </Link>
                <ul className="nav nav-second-level custmenu" id={itemId}>
                    {item.subItems.map((subItem, i) =>
                        <li key={i} className={subItem.style}>
                            <Link to={subItem.url}>
                                <span className="nav-label">{_.capitalize(subItem.label)}</span>
                            </Link>
                        </li>
                    )}
                </ul>
            </li>
            : <li className={item.style}>
                <Link to={ item.url } >
                    <div className="mini-item">{_.capitalize(item.label.substring(0, 3))}</div>
                    <span className="nav-label">{_.upperCase(item.label)}</span>
                </Link>
            </li>;
        return renderItem;
    }
}

export default CustMenuItem;


// WEBPACK FOOTER //
// ./src/components/common/CustMenuItem.js